import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from "react-helmet";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      {/* تحسين العنوان والوصف لمحركات البحث */}
      <Helmet>
        <title>404 - الصفحة غير موجودة</title>
        <meta
          name="description"
          content="عذرًا، الصفحة التي تبحث عنها غير موجودة. حاول العودة إلى الصفحة الرئيسية للاستفادة من خدماتنا."
        />
      </Helmet>

      {/* تصميم الصفحة */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh", // ملء الشاشة بالكامل
          textAlign: "center",
          padding: "16px",
          backgroundColor: "#f9f9f9", // لون الخلفية (اختياري)
        }}
      >
        {/* صورة الخطأ */}
        <Box
          sx={{
            width: { xs: "80%", sm: "60%", md: "40%" }, // استجابة للحجم
            marginBottom: "20px",
          }}
        >
          <LazyLoadImage
            src="/images/error.webp" // تأكد من وضع الصورة في المسار الصحيح
            alt="404 - الصفحة غير موجودة"
            effect="default"
            decoding="async"
            style={{
              width: "20%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* النصوص */}
        <Typography
          variant="h5"
          sx={{
            color: "text.primary",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          404 - الصفحة غير موجودة
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            marginBottom: "16px",
          }}
        >
          عذرًا، الصفحة التي تبحث عنها غير موجودة. يمكنك العودة إلى الصفحة
          الرئيسية.
        </Typography>

        {/* زر العودة إلى الصفحة الرئيسية */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(`/`)}
          sx={{
            padding: "8px 16px",
            fontSize: "16px",
            textTransform: "none",
          }}
        >
          العودة إلى الصفحة الرئيسية
        </Button>
      </Box>
    </>
  );
}

export default NotFound;
